/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1025px){.data-block__value[_ngcontent-%COMP%]{min-width:600px}}"];
export { styles as styles };
